<template>
  <b-modal id="create" hide-footer>
    <template v-slot:modal-title> Nova variável para contrato</template>
    <div class="d-block">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <LabelRequiredField label="tabela" />

            <select
              v-model="table_name"
              class="form-control"
              @change="onTableChange"
            >
              <option :value="'RESIDENT'">Resident</option>
              <option :value="'CUSTOMER'">Customer</option>
              <option :value="'REST_HOME'">Rest Home</option>
            </select>
          </div>

          <div v-if="columnsTableSelected.length != 0" class="col-md-12">
            <LabelRequiredField label="Coluna" />

            <select v-model="column_name" class="form-control">
              <option
                v-for="column in columnsTableSelected"
                :key="column"
                :value="column"
              >
                {{ column }}
              </option>
            </select>
          </div>

          <div class="col-md-12">
            <LabelRequiredField label="Nome da variável" />

            <input type="text" v-model="variable" class="form-control" />
          </div>

          <div class="col-md-12">
            <LabelRequiredField label="descrição da varivel" />

            <textarea
              v-model="description"
              class="form-control"
              maxlength="255"
            ></textarea>
          </div>

          <ErrorsMessages :errors="errors" />

          <div class="col-md-12 text-right">
            <v-btn
              :disabled="loading"
              type="submit"
              class="v-success"
              @click="create"
            >
              <span class="fa fa-check"></span>
              {{ loading ? "Carregando" : "Salvar" }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../components/ErrorsMessages";

import LabelRequiredField from "../components/LabelRequiredField";

import api from "../../services/api";

import toast from "../../components/ToastNotification";

export default {
  name: "CreateModal",

  components: {
    LabelRequiredField,
    ErrorsMessages,
  },

  props: {
    columnsResident: {
      type: Array,
      default: () => [],
    },

    columnsCustomer: {
      type: Array,
      default: () => [],
    },

    columnsRestHome: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      loading: false,

      errors: [],

      columnsTableSelected: [],

      table_name: "",

      column_name: "",

      variable: "",

      description: "",
    };
  },

  methods: {
    async create() {
      try {
        this.loading = true;

        const { table_name, column_name, variable, description } = this;

        let params = {
          table_name,
          column_name,
          variable,
          description,
        };

        const response = await api.post("/admin/contract/create", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.table_name = "";
          this.column_name = "";
          this.variable = "";
          this.description = "";
          this.errors = [];

          this.$bvModal.hide("create");

          this.$emit("create");

          toast(message, "success");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    onTableChange() {
      if (this.table_name == "RESIDENT") {
        this.columnsTableSelected = this.columnsResident;
      } else if (this.table_name == "CUSTOMER") {
        this.columnsTableSelected = this.columnsCustomer;
      } else if (this.table_name == "REST_HOME") {
        this.columnsTableSelected = this.columnsRestHome;
      }
    },
  },
};
</script>